<template>
  <div id="app">
    <Header routeValue="5" ref="header"></Header>
    <content class="faqs_content" @click="handleDel()">
      <div class="banner_box">
        <div class="banner_content">
          Frequently Asked<br>
          Questions (FAQ)<br>
          <span class="banner_underline"></span>
        </div>
      </div>
      <div class="topics_box">
        <div class="title">
          FAQ Topics
        </div>
        <div class="faq-topic" @click="scrollToAnchor('general-anchor')">
          <div class="topic-title">
            <img src="@/assets/icon/faq_topic01.png" class="topic-icon">
            General Questions
          </div>
          <div class="topic-des">
            Answers to general questions such as<br>
            "How do I place an order for samples?"
          </div>
        </div>
        <div class="faq-topic" @click="scrollToAnchor('fulfill-anchor')">
          <div class="topic-title">
            <img src="@/assets/icon/faq_topic02.png" class="topic-icon">
            Fulfill Orders
          </div>
          <div class="topic-des">
            Answers to general questions such as<br>
            "How to fulfill orders to Printbelle?"
          </div>
        </div>
        <div class="faq-topic" @click="scrollToAnchor('payment-anchor')">
          <div class="topic-title">
            <img src="@/assets/icon/faq_topic03.png" class="topic-icon">
            Payments
          </div>
          <div class="topic-des">
            Answers to general questions such as<br>
            "How to topup on printbelle system?"
          </div>
        </div>
        <div class="faq-topic" @click="scrollToAnchor('shipping-anchor')">
          <div class="topic-title">
            <img src="@/assets/icon/faq_topic04.png" class="topic-icon">
            Shipping
          </div>
          <div class="topic-des">
            Answers to general questions such as<br>
            "What is the shipping time?"
          </div>
        </div>
        <div class="faq-topic" @click="scrollToAnchor('refund-anchor')">
          <div class="topic-title">
            <img src="@/assets/icon/faq_topic05.png" class="topic-icon">
            Returns & Refunds
          </div>
          <div class="topic-des">
            Answers to general questions such as<br>
            "What is the Printbelle return & refund policy?"
          </div>
        </div>
      </div>
      <div class="general_questions_box" id="general-anchor">
        <div class="faq-container">
          <div class="title">GENERAL QUESTIONS</div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 0)">
              How do I place an order for samples?
              <img :src="activeIndexGeneral === 0 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 0">
              If you require a sample for quality checking, you can place an order for samples on the system just like a
              regular order.<br>
              If you need pictures of specific products, please contact the Printbelle support team. We will provide you
              with images of the available samples.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 1)">
              Can you send the mockup file to us?
              <img :src="activeIndexGeneral === 1 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 1">
              You can generate mockups on system designer, and here is a guide:<br>
              <a href="https://www.youtube.com/watch?v=cymEUWKE3H4" target="_blank" style="text-decoration: underline;">https://www.youtube.com/watch?v=cymEUWKE3H4</a>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 2)">
              Can you send the product template?
              <img :src="activeIndexGeneral === 2 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 2">
              You can download the production artwork template on the website or search from the system product
              designer.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 3)">
              How is fulfillment time with Printbelle?
              <img :src="activeIndexGeneral === 3 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 3">
              Our Fulfillment Time ⏱️<br>
              <b>- From China to the US:</b> 7 - 12 days (Yun express & SF express)<br>
              <b>- Production time:</b> 24 - 72 hours（80% products）<br>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 4)">
              How to improve the system level of Printbelle?
              <img :src="activeIndexGeneral === 4 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 4">
              Printbelle current membership levels (and their requirements) are:<br>
              <br>
              <div class="answer">
                <img src="../assets/icon/bronze.png"/>
                &nbsp;T1 = Bronze <200 ORDERS / DAY
              </div>
              <div class="answer">
                <img src="../assets/icon/platinum.png"/>
                &nbsp;T2 = Platinum 200-1000 ORDERS / DAY
              </div>
              <div class="answer">
                <img src="../assets/icon/diamond.png"/>
                &nbsp;T3 = Diamond >1000 ORDERS / DAY
              </div>
              <br>
              The higher the membership level, the higher the discount on product prices.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 5)">
              What are your company's best - performing products in terms of sales?
              <img :src="activeIndexGeneral === 5 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 5">
              Our best-selling products vary with different seasons and festivals, and the primary categories of these
              top-selling items include gift ornaments, household decor, drinkware, and clothing accessories.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 6)">
              Where to check Printbelle quotations?
              <img :src="activeIndexGeneral === 6 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 6">
              There are 3 methods to check quotations:<br>
              (1)System products categories<br>
              (2)Website products info<br>
              (3)Quotation table
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 7)">
              Do you offer custom packaging?
              <img :src="activeIndexGeneral === 7 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 7">
              Yes, we can customize the packaging as you would like, including logos, customized bags, cards, and more.
              The customization cost needs to be covered by you.<br>
              <br>
              Additionally, there is an MOQ for customized packaging: your daily order volume must be over 100 units to
              qualify for this service.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 8)">
              What is Printbelle's daily maximum order capacity?
              <img :src="activeIndexGeneral === 8 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 8">
              Our daily fulfilled orders average over <b>70,000</b>
              , and we currently possess the capacity to process <b>80,000</b>
              orders when peak seasons come.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 9)">
              Where is your factory located?
              <img :src="activeIndexGeneral === 9 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 9">
              We've established a modern production base of over <b>10,000</b> square meters in Fujian.<br>
              <br>
              In 2025, we have continued to increase investment in our US factories. Currently, US-based product
              fulfillment includes canvas, blankets, beach towels, door mats, mugs, caps, etc.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 10)">
              How many members does Printbelle team have?
              <img :src="activeIndexGeneral === 10 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 10">
              We currently have more than 300 excellent team members on board, and our team is still expanding robustly!
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 11)">
              What advantages are there to working with Printbelle?
              <img :src="activeIndexGeneral === 11 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 11">
              Our Advantages<br>
              <b>- Advanced Production:</b> We've established a modern production base
              of over 10,000 square meters in
              Fujian.<br>
              <b>- Factory - direct Supply:</b> As a source factory, we cut out
              middlemen, offering affordable prices, strict
              quality control, and personalized customization to meet your unique needs.<br>
              <b>- Diverse Products:</b> Our product range is rich and varied, covering
              home decor, clothing, drinkware,
              blankets and quilts, doormats, etc.We master multiple printing techniques, such as UV printing,
              Sublimation, DTG, DXF, Tumbler Machines, Water transfer print, etc.<br>
              <b>- PRINT in USA:</b> In 2025, we continued to increase investment in our
              US factories. Currently, product
              fulfillment from the US includes Canvas Frame (Multiple Sizes), Blanket, Beach Towel, Door mat, etc.<br>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 12)">
              What guarantees do we get when working with Printbelle?
              <img :src="activeIndexGeneral === 12 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 12">
              Our Guarantees<br>
              - Quick response with 1 - on - 1 exclusive service for each customer.<br>
              - Rapid new product development to keep you at the forefront of market trends and ahead of the
              competition.<br>
              - Photography services help sellers shoot high-quality product videos in a timely manner, giving a boost
              to promotion.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 13)">
              Does Printbelle impose a minimum order quantity (MOQ) requirement?
              <img :src="activeIndexGeneral === 13 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 13">
              No MOQ applies to our orders—we fully support single-piece orders.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 14)">
              Can Printbelle support FBA orders?
              <img :src="activeIndexGeneral === 14 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 14">
              Yes, we boast years of expertise in FBA order processing, maintain a thorough quality inspection process,
              and provide various logistics channels to opt for.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 15)">
              Can Printbelle support TikTok orders?
              <img :src="activeIndexGeneral === 15 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 15">
              TikTok US Shipping Process<br>
              Currently, we only support the fulfillment of TikTok orders in the United States and offer <b>2</b>
              shipping
              methods option:<br>
              <b>1. Use our logistics for shipping:</b><br>
              - Directly place an order with Print in USA products. Total cost is the selling price on the website.<br>
              <b>2. Use TikTok label for shipping:</b><br>
              - We will provide a new product link. Total cost is product cost + labeling cost.<br>
              - Need provide the TikTok label link in the order file "Shape" column when placing an order.

            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('general', 16)">
              How can I contact Printbelle support team?
              <img :src="activeIndexGeneral === 16 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexGeneral === 16">
              Printbelle offers the following contact and support channels:<br>
              Live chat on the Printbelle app: The chatbox is situated in the bottom right corner of the app interface.
              You can reach out to the Printbelle team via <b>Microsoft Teams, WeChat or Lark.</b>
            </div>
          </div>
        </div>
      </div>
      <div class="fulfill_orders_box" id="fulfill-anchor">
        <div class="faq-container">
          <div class="title">FULFILL ORDERS</div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 0)">
              How to fulfill orders to Printbelle?
              <img :src="activeIndexFulfill === 0 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 0" style="background-color: #F4F4F4">
              Current, Printbelle provide the following three methods:<br>
              <span style="font-weight: 500">①<b>CSV</b></span><br>
              <span style="font-weight: 500">②<b>API</b></span><br>
              <span style="font-weight: 500">③<b>ORDERDESK</b></span><br>
              The simplest and most commonly used way, <b>CSV tutorial:
              <a href="https://www.youtube.com/watch?v=VAXvyeXznNk" target="_blank"
                 style="text-decoration: underline;">https://www.youtube.com/watch?v=VAXvyeXznNk</a></b>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 1)">
              How can my store connect with Printbelle?
              <img :src="activeIndexFulfill === 1 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 1" style="background-color: #F4F4F4">
              We support connecting to your store via <b>API</b> , please see the
              detailed operation:<br>
              <a href="https://www.printbelle.com/help/details/how-to-integrate-the-marketplace-with-printbelle-api"
                 target="_blank" style="text-decoration: underline;">https://www.printbelle.com/help/details/how-to-integrate-the-marketplace-with-printbelle-api</a>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 2)">
              How to check the product code?
              <img :src="activeIndexFulfill === 2 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 2" style="background-color: #F4F4F4">
              There are 3 methods to check product code:<br>
              (1)System products categories<br>
              (2)Website products info<br>
              (3)Quotation table
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 3)">
              Can I get a discount if I place multiple orders to be delivered to the same location?
              <img :src="activeIndexFulfill === 3 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 3" style="background-color: #F4F4F4">
              Yes, we provide a discount for multiple items of the same product when they’re ordered together in one
              order.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 4)">
              How can I report an issue with my order?
              <img :src="activeIndexFulfill === 4 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 4" style="background-color: #F4F4F4">
              When there is an issue with an order, you can:<br>
              Reach out to our team through <b>live chat</b>
              or contact us for further assistance at: <b><a href="mailto:support@printbelle.com">support@printbelle.com.</a></b><br>
              Reviewed by the Printbelle team and responded to via email within 24 hours of submission.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 5)">
              I updated the wrong artwork for my order. How can I do?
              <img :src="activeIndexFulfill === 5 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 5" style="background-color: #F4F4F4">
              The wrong "artwork" is provided in the order. In this case, please contact our team on time. We will try
              our best to modify the correct "artwork" for you before production.<br>
              If the product has been shipped, you should alert the customer that the packaging may be wrong and please
              reorder the correct design.<br>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 6)">
              Is it necessary for me to remind you about new orders?
              <img :src="activeIndexFulfill === 6 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 6" style="background-color: #F4F4F4">
              When an order’s payment is successfully completed in the system, we will take the initiative to process
              it, so no reminder is required.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('fulfill', 7)">
              When is it possible to edit my order?
              <img :src="activeIndexFulfill === 7 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexFulfill === 7" style="background-color: #F4F4F4">
              You can edit an order while it is in an unpaid status.<br>
              Before the order is marked as <b>'Confirmed'</b> and <b>'Paid'</b> , please ensure that all order
              information is accurate, <br>
              including <b>'Address Details'</b>, <b>'Artwork'</b>, <b>'Shipping Method'</b> , etc.<br>
              If you wish to modify the order information after payment, please contact our team for assistance. Please
              note<br>
              that we cannot guarantee timely delivery after production in such cases.<br>
            </div>
          </div>
        </div>
      </div>
      <div class="payments_box" id="payment-anchor">
        <div class="faq-container">
          <div class="title">PAYMENTS</div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('payment', 0)">
              How to topup on printbelle system?
              <img :src="activeIndexPayment === 0 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexPayment === 0">
              <b>Step 1:</b> Printbelle APP > Billing > Wallet > Top up<br>
              <b>Step 2:</b> Select Payment methods > Fill in infos as requested
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('payment', 1)">
              Which payment methods are accepted?
              <img :src="activeIndexPayment === 1 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexPayment === 1">
              Available Payment Methods:<br>
              <b>1.Instant Top-up (No Manual Review Needed)</b><br>
              ①LianLian Global<br>
              ②Payoneer<br>
              ③WorldFirst<br>
              ④PingPong<br>
              ⑤Airwallex<br>

              <b>2.Manual Top-up(Need manual review, please contact us so we can approve your balance quickly.)</b><br>
              ①Payoneer<br>
              ②PingPong<br>
              ③PayPal(Mass Payment)<br>
              ④Bank Transfer<br>

              <b>3.Credit Card</b>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('payment', 2)">
              When do payments need to be settled?
              <img :src="activeIndexPayment === 2 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexPayment === 2">
              After you place an order, you’ll need to finish making the payment first—only then will we process the
              order.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('payment', 3)">
              Can we fulfill the order first and pay later?
              <img :src="activeIndexPayment === 3 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexPayment === 3">
              At the moment, we do not provide arrears credit. If you have any requirements in this regard, please
              contact us initially.
            </div>
          </div>
        </div>
      </div>
      <div class="shipping_box" id="shipping-anchor">
        <div class="faq-container">
          <div class="title">SHIPPING</div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 0)">
              What is the shipping time?
              <img :src="activeIndexShipping === 0 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 0" style="background-color: #F4F4F4">
              Using the United States as an example, we provide estimated delivery times for each shipping method based
              on historical data.<br>
              <b>Standard Shipping:</b> 5-10 business days<br>
              <b>Standard Shipping (Fast):</b> 3-7 business days<br>
              <b>Express Shipping:</b> 3-5 business days<br>

              <b>International Shipping Time:</b> 3-21 days<br>
              The information provided summarizes past shipping data. As international shipping becomes more efficient
              and faster, most countries typically receive deliveries within 3-21 business days. However, we cannot
              guarantee absolute punctuality in logistics, as delivery times are heavily influenced by carriers,
              transportation conditions, local policies, and uncontrollable factors such as weather. While timely
              delivery is not entirely within our control, Printbelle recognizes its significance to buyers. Hence, we
              will promptly update all POD Sellers on shipping progress to facilitate communication with buyers in case
              of any modifications.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 1)">
              What is the difference between shipping methods？
              <img :src="activeIndexShipping === 1 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 1" style="background-color: #F4F4F4">
              <b>STANDARD SHIPPING --Recommended - Most favorable</b><br>
              ex: USA<br>
              Mainly use SF express / Yun express: 7-12 normal days.<br>
              <br>
              <b>STANDARD SHIPPING(Fast)</b><br>
              ex: USA<br>
              Mainly use Yun express(Fast): 5-9 normal days.<br>
              <br>
              <b>FAST SHIPPING---Most expensive and fastest</b><br>
              ex: USA<br>
              Mainly use DHL / FEDEX/ UPS: 3-7 normal days.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 2)">
              How soon can I get the Tracking Number?
              <img :src="activeIndexShipping === 2 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 2" style="background-color: #F4F4F4">
              Under normal circumstances, the tracking number will be updated within <b>24-48</b> hours after payment
              for the
              order.<br>
              <br>
              Other special circumstances may be delayed, please check the details.<br>
              <a href="https://www.printbelle.com/help/details/how-soon-can-get-the-tracking-number" target="_blank"
                 style="text-decoration: underline;">https://www.printbelle.com/help/details/how-soon-can-get-the-tracking-number</a>
              .
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 3)">
              Does Printbelle charge taxes?
              <img :src="activeIndexShipping === 3 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 3" style="background-color: #F4F4F4">
              <b>Printbelle doesn’t charge tax on orders.</b><br>
              Printbelle ships packages <b>DDU (Delivery Duty Unpaid),</b> meaning import duties and taxes may apply for
              international shipments upon arrival. Sellers should be aware of potential costs before offering
              international shipping.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 4)">
              For European countries, is IOSS required for shipment?
              <img :src="activeIndexShipping === 4 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 4" style="background-color: #F4F4F4">
              No need to provide the IOSS, our logistics service provider will handle it.
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('shipping', 5)">
              Is it possible to resend/return packages?
              <img :src="activeIndexShipping === 5 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexShipping === 5" style="background-color: #F4F4F4">
              It mainly depends on the logistics carrier. Normally returned packages will be destroyed, and some
              packages may be allowed to be delivered again after paying for the resend shipping fee.
            </div>
          </div>
        </div>
      </div>
      <div class="returns_refunds_box" id="refund-anchor">
        <div class="faq-container">
          <div class="title">RETURNS & REFUNDS</div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('refund', 0)">
              What is the Printbelle return & refund policy?
              <img :src="activeIndexRefund === 0 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexRefund === 0" style="background-color: #F4F4F4">
              Please check the details document:<br>
              <br>
              <a href="https://www.printbelle.com/help/details/policy-regarding-order-management" target="_blank"
                 style="text-decoration: underline;">https://www.printbelle.com/help/details/policy-regarding-order-management</a>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-question" @click="toggleFaq('refund', 1)">
              Do packages include return labels?
              <img :src="activeIndexRefund === 1 ? minusIcon : plusIcon" alt="Toggle" class="toggle-btn">
            </div>
            <div class="faq-answer" v-show="activeIndexRefund === 1" style="background-color: #F4F4F4">
              No. Returning products to China is too costly. Please refer to the Printbelle returns policy at: <br>
              <a href="https://printbelle.com/help/details/policy-regarding-order-management" target="_blank" style="text-decoration: underline;">https://printbelle.com/help/details/policy-regarding-order-management</a>
            </div>
          </div>
        </div>
      </div>
      <div class="about_us_box">
        <div class="cards-container">
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/faq_about01.png">
              <div class="image-overlay-text">2016</div>
              <div class="image-overlay-des">OUR BIRTH YEAR</div>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/faq_about02.png">
              <div class="image-overlay-text">10000m²</div>
              <div class="image-overlay-des">WAREHOUSE</div>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/faq_about03.png">
              <div class="image-overlay-text">300+</div>
              <div class="image-overlay-des">TEAM MEMBERS</div>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/faq_about04.png">
              <div class="image-overlay-text">20M+</div>
              <div class="image-overlay-des">PACKAGES SHIPPED</div>
            </div>
          </div>
        </div>
      </div>
      <div class="quote_box">
        <div class="title">
          Interested in what we offer? We’re ready to help!
        </div>
        <div class="des">
          We aim to understand your needs precisely so we can provide a perfect fit.<br>
          Tell us what you need, and we’ll put our best effort into supporting you.
        </div>
        <div class="content_button">
          <a :href="skypeConfig">
            <div class="contact">
              Request a Free Quote
            </div>
          </a>
        </div>
      </div>
      <section class="services_box">
        <h2>OUR SERVICES</h2>
        <h3>All the services you need all in one place</h3>
        <div class="services-container">
          <div class="service-item">
            <img src="../assets/icon/faq_service01.png" alt="Fast Production">
            <p>Fast Production</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service02.png" alt="Diverse Products">
            <p>Diverse Products</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service03.png" alt="MOQ=1">
            <p>MOQ=1</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service04.png" alt="Competitive Price">
            <p>Competitive Price</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service05.png" alt="Free Design Tool">
            <p>Free Design Tool</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service06.png" alt="Stable Logistics">
            <p>Stable Logistics</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service07.png" alt="A/S Support">
            <p>A/S Support</p>
          </div>
          <div class="service-item">
            <img src="../assets/icon/faq_service08.png" alt="Photography Services">
            <p>Photography Services</p>
          </div>
        </div>
      </section>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import countTo from 'vue-count-to'
import {get, post} from '@/api'

const plusIconSrc = require('@/assets/icon/plus.png')
const minusIconSrc = require('@/assets/icon/minus.png')
export default {
  name: 'FAQ',
  components: {
    Header,
    Footer,
    countTo
  },
  data () {
    return {
      plusIcon: plusIconSrc,
      minusIcon: minusIconSrc,
      // 各FAQ模块的活跃索引，-1表示没有展开的项
      activeIndexGeneral: -1,
      activeIndexFulfill: -1,
      activeIndexPayment: -1,
      activeIndexShipping: -1,
      activeIndexRefund: -1,

      visible: false,
      email: 'mailto:support@printbelle.com',
      skypeConfig: '',
      dataList: [],
      options: [],
      isLoading: false,
      form: {
        applyName: undefined,
        email: undefined,
        remark: undefined,
      },
      rules: {
        applyName: [{required: true, message: 'Please enter your name', trigger: 'blur'}],
        email: [
          {
            required: true,
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change']
          }
        ],
        remark: [{required: true, message: 'Please enter message', trigger: 'blur'}],
      },
      pageNum: 1,
      pageSize: 20
    }
  },
  mounted () {
    const hash = window.location.hash
    if (hash === '#step1') {
      window.scrollTo({
        top: 4050,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
    window.addEventListener('message', (event) => {
      if (event.data.type === 'ANCHOR_PARAM') {
        this.scrollToAnchor(event.data.anchor)
      }
    })
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    scrollToAnchor (anchorId) {
      const targetElement = document.getElementById(anchorId)
      if (!targetElement) return

      const headerHeight = 70
      const targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      })

      // 跳转后自动展开该模块的第一个问答
      this.expandFirstFaq(anchorId)
    },

    expandFirstFaq (anchorId) {
      switch (anchorId) {
        case 'general-anchor':
          this.activeIndexGeneral = 0
          break
        case 'fulfill-anchor':
          this.activeIndexFulfill = 0
          break
        case 'payment-anchor':
          this.activeIndexPayment = 0
          break
        case 'shipping-anchor':
          this.activeIndexShipping = 0
          break
        case 'refund-anchor':
          this.activeIndexRefund = 0
          break
      }
    },
    handleDel () {
      this.$refs.header.delProductValue()
    },
    getSkypeConfig () {
      this.skypeConfig = 'msteams://teams.microsoft.com/l/chat/0/0?users=luojiao@printbelle.com'
    },

    toDetailsDes (item) {
      this.$router.push({path: `/designs/${item.id}`})
    },
    handleOk (e) {
      this.visible = false
    },

    // 切换FAQ展开/收起状态
    toggleFaq (module, index, event) {
      if (event) {
        event.stopPropagation()
      }

      // 根据模块切换对应的索引
      switch (module) {
        case 'general':
          this.activeIndexGeneral = this.activeIndexGeneral === index ? -1 : index
          break
        case 'fulfill':
          this.activeIndexFulfill = this.activeIndexFulfill === index ? -1 : index
          break
        case 'payment':
          this.activeIndexPayment = this.activeIndexPayment === index ? -1 : index
          break
        case 'shipping':
          this.activeIndexShipping = this.activeIndexShipping === index ? -1 : index
          break
        case 'refund':
          this.activeIndexRefund = this.activeIndexRefund === index ? -1 : index
          break
      }
    }
  },
}
</script>
<style scoped lang="less">

.faq-mixin() {
  position: relative;

  .faq-container {
    width: 1320px;
    margin: 30px auto;
    padding: 20px;

    .title {
      margin-bottom: 19px;
      font-weight: 900;
      font-size: 23px;
      color: #222222;
    }
  }

  .faq-item {
    margin-bottom: 15px;
  }

  .faq-question {
    background-color: #012169;
    padding: 30px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    height: 80px;

    .toggle-btn {
      transition: transform 0.3s ease;
    }
  }

  .faq-answer {
    background-color: #FFFFFF;
    padding: 15px 30px;
    border-radius: 0 0 4px 4px;
    font-weight: 300;
    font-size: 18px;
    color: #111111;
    line-height: 26px;

    &.show {
      height: 500px; /* 展开时的最大高度 */
    }

    .answer {
      display: flex;
      align-items: center;
      margin-bottom: 5px
    }
  }
}

.faqs_content {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  font-family: HarmonyOS Sans SC;

  .banner_box {
    height: 535px;
    background-image: url(../assets/icon/faq_bg.png);
    position: relative;
    box-shadow: inset -20px 40px 20px -32px rgba(0, 0, 0, 0.07);
    //margin-top: 72px;

    .banner_content {
      position: absolute;
      top: 84px;
      left: 318px;
      width: 1024px;
      height: 177px;

      font-weight: 900;
      font-size: 40px;
      color: #FFFFFF;
      line-height: 47px;
    }

    .banner_underline {
      display: inline-block;
      width: 142px;
      height: 3px;
      background-color: #FFFFFF;
      margin: 39px 0;
    }
  }

  .topics_box {
    background: #ffffff;
    padding: 53px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px;
    max-width: 1261px;
    margin: 0 auto;

    .title {
      font-weight: 900;
      font-size: 44px;
      color: #111111;
      width: 100%;
      text-align: left;
    }

    .faq-topic {
      width: calc(33.333% - (40px / 3));
      margin-top: 25px;
      cursor: pointer;
      transition: transform 0.2s ease;

      &:hover {
        transform: scale(1.02);
      }
    }

    .topic-title {
      font-weight: 400;
      font-size: 26px;
      color: #012169;
      display: flex;
      align-items: center;
      gap: 9px;

      .topic-icon {
      }
    }

    .topic-des {
      width: 372px;
      margin-top: 8px;
      font-weight: 300;
      font-size: 18px;
      color: #111111;
      line-height: 26px;
      margin-left: 61px;
    }
  }

  .general_questions_box {
    .faq-mixin();
    background-image: url(../assets/icon/faq_general_questions_bg.png);
    margin-top: 33px;
    background-size: 100% 1770px;
    background-repeat: no-repeat;
    background-color: #F4F4F4;
  }

  .fulfill_orders_box {
    .faq-mixin();
    background-size: 100% 100%;
    background: #FFFFFF no-repeat;
    margin-top: 15px;
  }

  .payments_box {
    .faq-mixin();
    background-image: url(../assets/icon/faq_payment_bg.png);
    margin-top: 33px;
    background-size: 100% 533px;
    background-repeat: no-repeat;
    background-color: #F4F4F4;
  }

  .shipping_box {
    .faq-mixin();
    background-size: 100% 100%;
    background: #FFFFFF no-repeat;
  }

  .returns_refunds_box {
    .faq-mixin();
    background-size: 100% 100%;
    background: #FFFFFF no-repeat;
    margin-top: -65px;
  }

  .about_us_box {
    width: 1280px;
    height: 464px;
    margin: 18px auto;
    text-align: center;
    background: #F4F4F4;
    border-radius: 26px;

    .cards-container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 85px 109px;

      .card {
        .image-with-text {
          display: inline-block;
          width: 100%;
          position: relative;

          .img {
            display: block;
            margin-bottom: 0;
          }
        }

        .image-overlay-text {
          position: absolute;
          bottom: 23px;
          align-items: center;
          justify-content: center;
          left: 0;
          right: 0;
          font-weight: 900;
          font-size: 50px;
          color: #111111;
          display: flex;
          top: 215px;
        }

        .image-overlay-des {
          position: absolute;
          bottom: 23px;
          align-items: center;
          justify-content: center;
          left: 0;
          right: 0;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
          display: flex;
          top: 260px;
        }
      }
    }
  }

  .quote_box {
    background-image: url(../assets/icon/faq_quote_bg.png);
    height: 523px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 65px;

    .title {
      margin-top: 150px;
      font-weight: 900;
      font-size: 40px;
      color: #012169;
    }

    .des {
      margin-top: 23px;
      font-weight: 300;
      font-size: 18px;
      color: #012169;
      line-height: 24px;
    }

    .content_button {
      margin-top: 50px;
      width: 262px;
      height: 47px;
      background: #012169;
      border-radius: 24px;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;

      .contact {
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        margin-top: 10px;
      }
    }
  }

  .services_box {
    width: 1370px;
    height: 645px;
    margin: 55px auto 0 auto;
    text-align: center;
    padding: 50px;
  }

  .services_box h2 {
    font-weight: 900;
    font-size: 55px;
    color: #222222;
    line-height: 24px;
  }

  .services_box h3 {
    font-weight: 400;
    font-size: 20px;
    color: #888A96;
    margin-top: -3px;
    margin-bottom: 20px;

  }

  .services_box p {
    font-weight: 400;
    font-size: 26px;
    color: #111111;
    margin: 50px auto;
    white-space: nowrap;
    overflow: visible;
  }

  .services-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .service-item {
    width: 25%;
    box-sizing: border-box;
    padding: 32px 20px;
    text-align: center;
  }

  .service-item img {
    height: auto;
    margin-bottom: 30px;
    max-width: 100%;
  }

  .service-item p {
    margin: -12px;
  }
}

/deep/ .ant-modal-close-x {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Faqs.vue